import React from 'react';
import horlogerieImage from '../../images/horlogerie.jpg';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function HorlogeriePage() {
    const seo = CATEGORIES_SEO.horlogerie;
    const details = [
        'Pendules de cheminée',
        'Pendules de parquet',
        'Montres de poche',
        'Montres de poignet',
        'Pendules murales',
        'Horloges anciennes',
        'Mécanismes délicats',
        'Montres signées par Rolex, Omega, Lip, Zenith, Patek Philippe, et autres',
        'Modèles en or, acier, et platine',
    ];

    const description = `
        En tant qu’antiquaire passionné par l’art horloger, je suis à la recherche de toutes pièces en horlogerie, qu’elles soient anciennes ou rares. Je rachète avec intérêt des pendules de cheminée, des pendules de parquet, des montres de poche, des montres de poignet, ainsi que des pendules murales de toutes époques. Que ce soit des modèles de prestige ou des pièces plus modestes, je suis également à l’affût des horloges anciennes, des mécanismes délicats et des montres signées par de grands maîtres horlogers. Si vous possédez des objets d’horlogerie à vendre, n’hésitez pas à me contacter. Je vous offre une évaluation sérieuse et des propositions d’achat adaptées à la valeur de vos pièces.

        Je suis à la recherche de montres d’exception signées par des créateurs renommés tels que Rolex, Omega, Lip, Zenith, Patek Philippe, et d’autres. Je privilégie les modèles en or, acier et platine. Chaque montre étant une œuvre d’art, je serais ravi d’acquérir des pièces prestigieuses incarnant l’élégance et le savoir-faire horloger. N’hésitez pas à me contacter si vous en possédez.
    `;

    return (
        <CategoryPage
            title="Horlogerie"
            image={horlogerieImage}
            description={description}
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default HorlogeriePage;
